module.exports = __webpack_public_path__ + "static/media/fluminense.7f3699b5.svg";